import { render, staticRenderFns } from "./Swatches.vue?vue&type=template&id=6041ca22&scoped=true&"
import script from "./Swatches.vue?vue&type=script&lang=js&"
export * from "./Swatches.vue?vue&type=script&lang=js&"
import style0 from "./Swatches.vue?vue&type=style&index=0&id=6041ca22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6041ca22",
  null
  
)

export default component.exports